// Discovery only. The bank-review API independently proves permission, account scope and reviewer identity.
export const getBankReviewAccess = (user) => {
  const claims = Array.isArray(user?.Claims) ? user.Claims : [];
  return {
    viewList: claims.includes("bankAccount.viewList"),
    viewDetails: claims.includes("bankAccount.viewDetails"),
    manage: claims.includes("bankAccount.manageBankMatchStatus"),
  };
};

export const canOpenBankReviews = (user) => {
  const access = getBankReviewAccess(user);
  return access.viewList || access.viewDetails;
};

/** Preserve only our local queue/case route across sign-in, never an arbitrary return URL. */
export const bankReviewReturnPath = (location) => {
  if (typeof location === "string") {
    const match = /^(\/app\/bankaccounts\/reviews)(\?[^#]*)?$/.exec(location);
    if (!match) return null;
    location = { pathname: match[1], search: match[2] || "" };
  }
  if (location?.pathname !== "/app/bankaccounts/reviews" || location.hash) return null;
  const params = new URLSearchParams(location.search || "");
  const entries = Array.from(params.entries());
  if (!entries.length) return "/app/bankaccounts/reviews";
  if (entries.length !== 1 || entries[0][0] !== "caseId") return null;
  const id = entries[0][1];
  if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id) || /^0{8}-0{4}-0{4}-0{4}-0{12}$/.test(id)) return null;
  return `/app/bankaccounts/reviews?caseId=${id}`;
};

export const bankReviewSignInPath = (location) => {
  const path = bankReviewReturnPath(location);
  return path ? `/signin?bankReviewReturn=${encodeURIComponent(path)}` : "/signin";
};

export const bankReviewLoginReturnPath = (location) => {
  const from = bankReviewReturnPath(location?.state?.from);
  if (from) return from;
  const params = new URLSearchParams(location?.search || "");
  return params.getAll("bankReviewReturn").length === 1 ? bankReviewReturnPath(params.get("bankReviewReturn")) : null;
};
